module.exports = __webpack_public_path__ + "static/media/ria.07afc46e.png";